define('SageDotCom/DataLayer/Global/carousel',['jquery',
        'SageDotCom/DataLayer/tealium',
        'SageDotCom/DataLayer/Events/carouselCustomerStory',
        'SageDotCom/DataLayer/Events/carouselGeneric',
        'SageDotCom/DataLayer/Events/carouselHero',
        'SageDotCom/DataLayer/Util/trackingHelper',
        'SageDotCom/DataLayer/Util/htmlHelper',
        'SageDotCom/DataLayer/Util/jQueryExtensions'],
    function ($, tealium, customerStory, generic, hero, trackingHelper, htmlHelper) {
        function globalCarouselTracking() { }

        function deriveControl(e) {
            var control = 'select';

            if (e.currentTarget.className.indexOf('carousel-control') !== -1) {
                var direction = e.currentTarget.className.indexOf('right') !== -1 ? 'right' : 'left';
                control = direction;
            }

            return control;
        }

        function getEventType(carousel) {
            if ($(".hero--customer-quote", carousel).length > 0) {
                // customer success carousel
                return customerStory;
            } else if ($("h1, .score-hero", carousel).length > 0) {
                // hero carousel
                return hero;
            }

            // normal carousel
            return generic;
        }

        function deriveMenu(e, carousel) {
            var $paneId = '(not set)';
            var $current = $('.score-carousel-pic-pane.active', carousel);

            if ($(e.currentTarget).attr('data-slide-to')) {
                var index = $(e.currentTarget).attr('data-slide-to');

                if (!isNaN(index)) {
                    index = parseInt(index);
                    // carousel pane is identified by paneId

                    $paneId = $($(".score-carousel-pic-pane")[index]).attr('id');
                } else {
                    $paneId = index;
                }

            } else if (e.currentTarget.className.indexOf('left') !== -1) {
                // transitioning left
                $paneId = $current.prevOrLast('.score-carousel-pic-pane').attr('id');
            } else if (e.currentTarget.className.indexOf('right') !== -1) {
                // transitioning right
                $paneId = $current.nextOrFirst('.score-carousel-pic-pane').attr('id');
            }
            
            return $paneId;
        }

        globalCarouselTracking.prototype.initialize = function initialize() {
            $(".score-carousel:not([data-xpr-state], [data-tracking])").each(function (key, carousel) {
                var event = getEventType(carousel);
                $(".carousel-control, .carousel-indicators li", carousel).click(function (e) {
                    var control = deriveControl(e);
                    var menu = deriveMenu(e, carousel);
                    var obj = event.GenerateEventMetadata(carousel, control, menu);

                    tealium.event(obj);
                });
                trackingHelper.registerTracking(carousel, event.getName());
            });
        }

        return new globalCarouselTracking();
    });
